import { global as theme } from '@probeton/style';

export default theme;
